export default {
    navigationBarTitleText: "进度详情",
  };
  